import { render, staticRenderFns } from "./bi-finance-info-section.vue?vue&type=template&id=3e2d04cb&"
import script from "./bi-finance-info-section.vue?vue&type=script&lang=ts&"
export * from "./bi-finance-info-section.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports